import React, { forwardRef, useState } from "react";
// import "./CreateMember.css";
// import "../../components/CommonStyle.css";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  updateMember_Sections,
  updateMember_Tags,
} from "../../store/memberApiSlice";
interface ISection {
  [key: string]: any;
}
interface IProps {
  labels: ISection[];
  isSection: boolean;
  onChangeFunction: (
    event: React.ChangeEvent<HTMLInputElement>,
    inFlag: boolean
  ) => void;
}

const FMSelectMultipleOptionItems: React.FC<IProps> = (props) => {
  // const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const dispatch = useDispatch();
  // const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log("checked..", event.target.checked);
  //   // setSelectedItems(...setSelectedItems, event.target.id);
  //   if( event.target.checked){
  //     console.log("checked")
  //     setSelectedItems((selectedItems) => [
  //       ...selectedItems,
  //       Number(event.target.id),
  //     ]);
  //   }else{
  //     console.log("un checked")
  //     setSelectedItems(selectedItems =>
  //       selectedItems.filter(item => {
  //         return item !== Number(event.target.id);
  //       }),);

  //   }

  //   console.log("selectedItems : ", selectedItems);
  //   if (props.isSection) {
  //     dispatch(updateMember_Sections(selectedItems));
  //   } else {
  //     dispatch(updateMember_Tags(selectedItems));
  //   }
  // };

  // const sections = props.labels;
  const labels = props.labels;

  return (
    <div className="sections-section">
      {labels.map((label, index) =>
        label.Status ? (
          <div key={label.Id} className="checkboxgroup-find">
            <div className="checkboxgroup-buttons">
              <input
                id={label.Id}
                className="checkbox-find"
                // name={props.isSection ? `sec-${label.Id}` : `mem-${label.Id}`}
                name={props.isSection ? label.SectionName : label.MemberTag}
                type="radio"
                onChange={(e) => props.onChangeFunction(e, true)}
              />
              <span style={{ marginRight: "0.5rem" }}>In</span>
              <input
                id={label.Id}
                className="checkbox-find"
                // name={props.isSection ? `sec-${label.Id}` : `mem-${label.Id}`}
                name={props.isSection ? label.SectionName : label.MemberTag}
                type="radio"
                onChange={(e) => props.onChangeFunction(e, false)}
              />
              <span
                style={{
                  marginRight: "0.5rem",
                  width: "60px",
                  whiteSpace: "nowrap",
                }}
              >
                Not in
              </span>
            </div>
            <div className="section-text" style={{ fontWeight: "500" }}>
              {props.isSection ? (
                <>
                  {/* <span>
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(label.Fee as number)}
                </span> */}

                  <span> {label.SectionName}</span>
                </>
              ) : (
                <>
                  {/* <span>
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(label.Fee as number)}
                </span> */}

                  <span> {label.MemberTag}</span>
                </>
              )}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

export default FMSelectMultipleOptionItems;
